import React from 'react'
import LinearProgress from '@material-ui/core/LinearProgress'

import styles from '../../styles/account.module.scss'

interface RemainingRewardsProps {
  label: string
  remaining: number
  total: number
}

const RemainingRewards: React.FC<RemainingRewardsProps> = props => {
  const { label, remaining, total } = props
  return (
    <div className={`${styles.status} ${styles.progress}`}>
      <div className={styles.details}>
        <p>{label}</p>
        <p className={styles.amount}>
          {remaining} / {total}
        </p>
      </div>
      <div style={{ paddingRight: 30 }}>
        <LinearProgress
          variant={'determinate'}
          value={remaining}
          style={{ height: 7, marginTop: 8 }}
        />
      </div>
    </div>
  )
}

export default RemainingRewards
